import { getBusinessDate, utcRange } from '@utils/date-time'
import { Venue } from 'types/model'

export function getVenuePurchaseRange(venue?: Venue): [string, string] {
  const purchaseWindow = venue?.inventoryTimeframe ?? 30

  const dateStart = getBusinessDate().valueOf()
  const [_, dateEnd] = utcRange(Date.now(), { days: purchaseWindow })

  return [String(dateStart), String(dateEnd)]
}
